export const shouldShowMobileChatRouteLoader = ({
  isMobileView,
  isBroadcastMode,
  patientId,
  patient,
  isLoadingPatient,
  roomId,
  activeRoomId,
  isLoadingMessages,
  messageCount = 0
}) => {
  if (!isMobileView || isBroadcastMode || !patientId) {
    return false
  }

  if (isLoadingPatient || patient?.id !== patientId) {
    return true
  }

  if (patient?.auth_status === 'added') {
    return false
  }

  if (!roomId) {
    return true
  }

  return activeRoomId !== roomId || (isLoadingMessages && messageCount === 0)
}
